<template>
    <Header></Header>
    <div class="alerts-container">
        <button class="debug-alert" @click="addAlert('Success', 'success-alert')" v-if="debug_mode">Show Alert</button>
        <div class="alerts-wrapper">
            <Alert
                v-for="alert in alerts"
                :key="alert.id"
                :class="alert.class"
                @closed="removeAlert(alert.id)"
            >
            {{ alert.message }}
            </Alert>
        </div>
    </div>
    <section v-if="userStore.isLoggedIn && userStore.current_user_groups.includes('ADMIN_PANEL')" class="main">
        <div class="field">
            <div class="searchbar">
                <i class="material-icons">search</i>
                <input type="text" v-model="searchInput" placeholder="Rechercher" autocomplete="off">
            </div>
            <aside class="filter">
                <div class="filter-group">
                    <input class="btn" type="radio" id="affectation-all" name="affectation" v-model="filter.affectation" value="all">
                    <label for="affectation-all">Tous</label>
        
                    <input class="btn" type="radio" id="affectation-affected" name="affectation" v-model="filter.affectation" value="affected">
                    <label for="affectation-affected">Affectés</label>
        
                    <input class="btn" type="radio" id="affectation-stock" name="affectation" v-model="filter.affectation" value="En stock">
                    <label for="affectation-stock">En stock</label>

                    <input class="btn" type="radio" id="affectation-jete" name="affectation" v-model="filter.affectation" value="Jeté">
                    <label for="affectation-jete">Jeté</label>
                </div>

                <div>
                    <button class="primary-button-discret" @click="toggleScore = !toggleScore"><i class="material-icons">{{ toggleScore ? 'remove' : 'add' }}</i>Toggle Score</button>
                </div>
            </aside>
        </div>
        
        <Sub_InventoryTable
            :computers="computers"
            :toggleScore="toggleScore"
            :order="order"
            @selectedComputer="handleSelectedComputer"
            @updateOrder="updateOrder"
        ></Sub_InventoryTable>

        <aside>
            <Pagination
                :totalCount="total_count" 
                v-model:page="page"
                v-model:pageSize="page_size"
            ></Pagination>
        </aside>
    </section>

    <Modal v-model="openModal">
        <Sub_InventoryItemDetail
            :computer="selectedComputer"
            :isModal="true"
        ></Sub_InventoryItemDetail>
    </Modal>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useScoreColor }                             from '@/composables/useScoreColor';
import { useUserStore }                              from '@/stores/userstore';
import apiClient                                     from '@/api';
import Header                                        from '@/components/Header.vue';
import Alert                                         from '@/components/Alert.vue';
import Modal                                         from '@/components/Modal.vue';
import Sub_InventoryItemDetail                       from './Sub_InventoryItemDetail.vue';
import Pagination                                    from '@/components/Pagination.vue';
import Sub_InventoryTable                            from './Sub_InventoryTable.vue';

const userStore        = useUserStore()

const { getColor }     = useScoreColor()

const computers        = ref([])
const search           = ref('')
const searchInput      = ref('')
const selectedComputer = ref([])
const openModal        = ref(false)
const debug_mode       = ref(false)
const toggleScore      = ref(false)
let timeout            = null

const filter = reactive({
    affectation: 'all'
})


// order params
const order = reactive({
    overall_score: null,
    last_audit: null,
    current_affectation: 'desc'
})

const order_by_array = computed(() => {
    const orderings = []

    if (order.overall_score) {
        orderings.push(order.overall_score === 'desc' ? '-overall_score' : 'overall_score')
    }

    if (order.last_audit) {
        orderings.push(order.last_audit === 'desc' ? '-last_audit' : 'last_audit')
    }

    if (order.current_affectation) {
        console.log('current');
        orderings.push(order.current_affectation === 'desc' ? '-current_affectation' : 'current_affectation')
    }

    return orderings
})

const updateOrder = ({ field, direction }) => {
    if (field === 'overall_score') {

        if(order.overall_score){
            order.overall_score  = order.overall_score === 'asc' ? 'desc' : 'asc' 
        }
        else{
            order.overall_score = direction
        }
        order.last_audit = null
        order.current_affectation = null

        page.value = 1
    }

    else if (field === 'last_audit') {

        if(order.last_audit){
            order.last_audit  = order.last_audit === 'asc' ? 'desc' : 'asc' 
        }
        else{
            order.last_audit = direction
        }
        
        order.current_affectation = null
        order.overall_score = null

        page.value = 1
    }

    else if (field === 'affectation') {
        
        if(order.current_affectation){
            order.current_affectation  = order.current_affectation === 'asc' ? 'desc' : 'asc' 
        }
        else{
            order.current_affectation = direction
        }
        
        order.last_audit = null
        order.overall_score = null

        page.value = 1
    }
}

// pagination
const page        = ref(1)
const page_size   = ref(50)
const total_count = ref(0)

const getInventory = async () => {
    const params = {
        search: search.value,
        order_by: JSON.stringify(order_by_array.value),
        page: page.value,
        page_size: page_size.value,
        filter: JSON.stringify(filter)
    }
    
    try {
        console.log(params)
        const response = await apiClient.get('get_inventory/', { params })
        const data = response.data

        console.log('Status :',response.status)
        console.log(data.results.message, data.results.data)

        if (data.results.data !== undefined) {
            computers.value = data.results.data
        } else {
            computers.value = []
        }

        // handles next and previous page buttons
        if(data.count !== undefined) {
            total_count.value = data.count
        } else {
            total_count.value = computers.value.length
        }

        if(data.results.data.length > 0) {
            addAlert('Synchronisation des données réussie.', 'success-alert')
        } else {
            addAlert('Aucun résultat ne correspond aux paramètres de recherche.', 'warning-alert')
        }
    } catch (error) {
        if(error.response) {
            console.log(error.response.status)
            console.log(error.response.data.message)
        } else if (error.request) {
            console.log(error.request)
        } else {
            console.log(error.message)
        }
        addAlert("Une erreur est survenue lors de la récupération des données.", 'danger-alert')
    }
}

const handleSelectedComputer = (item) => {
    console.log(item)
    selectedComputer.value = item
    openModal.value = true
}

// alert handler start
const alerts  = ref([])
let idCounter = 0

const addAlert = (message, alertClass) => {
    const existingIndex = alerts.value.findIndex(a => a.message === message)

    // If alert already exists
    if (existingIndex !== -1) {
        const existingAlert = alerts.value[existingIndex]

        // Remove it from its current position
        alerts.value.splice(existingIndex, 1)

        // Force re-render (restart animation & timer)
        idCounter++
        existingAlert.id = idCounter
        existingAlert.class = alertClass

        // Add it back at the top
        alerts.value.unshift(existingAlert)
        return
    }

    // Otherwise create a new alert
    idCounter++

    alerts.value.unshift({
        id: idCounter,
        class: alertClass,
        message: message
    })
}

const removeAlert = (id) => {
    alerts.value = alerts.value.filter(a => a.id !== id)
}
// alert handler end

// input debounce
watch(searchInput, (newSearch, oldSearch, onCleanup) => {
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => {
        search.value = searchInput.value;
        page.value = 1 // reset page    
    }, 800);

    onCleanup(() => {
        clearTimeout(timeout)
    });
})

watch ([page, page_size, () => order_by_array.value.join(','), search], () => {
    getInventory()
})

watch (filter, () => {
    page.value = 1
    getInventory()
}, { deep: true })

onMounted(() => {
    getInventory()
	debug_mode.value = import.meta.env.DEV
})
</script>

<style lang="scss" scoped>
.main {
    background-color: white;
    margin: auto;
    margin-top: 1rem;
    max-width: 90vw;
    padding: 1rem;
    border-radius: 5px;

    @media (max-width: 768px) {
        max-width: 95%;
        padding: 0.5rem;
    }
}

.alerts-wrapper {
    position: fixed;
    bottom: 1vh;
    right: 3vw;
    display: flex;
    flex-direction: column;
    flex-flow: column-reverse;
    gap: 0.5rem;
    z-index: 9999;

    align-items: end;

    margin-left: 3vw;
}

.searchbar {
    display: flex;
    padding: 1rem;
    align-items: center;
    gap: 1rem;
    width: fit-content;
    border-radius: 15px;
    justify-content: start;
    margin: auto;

    span {
        color: $dark-blue;
        font-size: large;
        font-weight: bold;
    }
}

.text-center {
    text-align: center;
}

label:has(input[type='radio']) > input {
    display: none;
}


label:has(input[type='radio']) {
    cursor: pointer;
}

label:has(input[type='radio']:checked) {
    color: orange;
}

label {
    display: inline;
    gap: 0;
}

.filter {
    display: flex;
    align-items: center;
    justify-content: space-between;

    input[type="radio"] {
        display: none;

        + label {
            background-color: #fff;
            border: solid 2px $dark-blue;
            border-radius: 2px;
            color: $dark-blue;

            padding: 5px 9px;

            text-transform: uppercase;
        }

        &:checked + label {
            background-color: $dark-blue;
            color: #fff;
        }

        &:focus + label,
        &:hover + label {
            border: solid 2px $orange;
            color: $orange  ;

            cursor: pointer;
        }
    }

    .filter-group {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        padding-block: 1rem;

        align-items: center;
    }
}
</style>